module.exports = __webpack_public_path__ + "../../../static/img/se_bot.5b493125.png";